import React from "react";

const getItems = (question) => {
    const left = Array.isArray(question.configJson?.col_gauche) ? question.configJson.col_gauche : [];
    const right = Array.isArray(question.configJson?.col_droite) ? question.configJson.col_droite : [];

    if (left.length || right.length) {
        return { left, right };
    }

    const labels = (question.reponsesPossibles || []).map((option) => option.libelle);
    const middle = Math.ceil(labels.length / 2);
    return {
        left: labels.slice(0, middle),
        right: labels.slice(middle),
    };
};

export default function QuestionMatching({ question, value, onChange, disabled }) {
    const { left, right } = getItems(question);
    const selected = value && typeof value === "object" ? value : {};

    const handleSelect = (leftItem, rightItem) => {
        onChange({
            ...selected,
            [leftItem]: rightItem,
        });
    };

    return (
        <div className="qr-matching">
            {left.map((leftItem) => (
                <div key={leftItem} className="qr-matching-row">
                    <span className="qr-matching-left">{leftItem}</span>
                    <select
                        className="qr-select"
                        value={selected[leftItem] || ""}
                        onChange={(event) => handleSelect(leftItem, event.target.value)}
                        disabled={disabled}
                    >
                        <option value="">Choisir une correspondance</option>
                        {right.map((rightItem) => (
                            <option key={rightItem} value={rightItem}>
                                {rightItem}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
}
